import { FormRow, More } from "@omnabase/ui";
import { KEY_GROUPS, KEY_GROUP_LABELS, geminiModelOf, keyGroupPatch, type AiKeyRead, type KeyGroup } from "@omnabase/shared";
import { api } from "../../lib/api";
import { KEY_GROUP_HELP, keyModelOptionText } from "../../lib/aiKey";
import { useSession } from "../../shell/store";

// Settings › AI › Engine, "Advanced" on the key card (AI settings round four, 2026-10-20; brief rules 1 and 2): two questions instead of eight,
// the model for writing and the model for the quick work, each offering the newest Sonnet and the newest Haiku by name with their price. A
// choice writes the group's four kinds of work at once (the API takes whole groups only); a group whose stored kinds disagree (rows saved
// before this round) says "Mixed · choose once to align" until the next choice.

const MIXED = "Mixed · choose once to align";
/** round six (2026-10-21, the red team's item 21): the option names hide "preview" (the founder's copy "Gemini Pro 3.1"), so the group's help says it */
const PREVIEW = "A Google preview model: Google may replace it on short notice.";
const helpOf = (read: AiKeyRead, g: KeyGroup) => {
  const preview = geminiModelOf(read.groups[g].model)?.preview ? ` ${PREVIEW}` : "";
  return read.groups[g].mixed ? <>{KEY_GROUP_HELP[g]}{preview} <strong>{MIXED}</strong></> : `${KEY_GROUP_HELP[g]}${preview}`;
};

export function AiKeyModels({ read, url, onRead }: { read: AiKeyRead; url: string; onRead: (r: AiKeyRead) => void }) {
  const { toast } = useSession();
  const choose = async (group: KeyGroup, model: string) => {
    try { onRead(await api.patch<AiKeyRead>(url, { models: keyGroupPatch(group, model) })); }
    catch (e) { toast((e as Error).message, { kind: "error" }); }
  };
  return (
    <More label="Advanced">
      {KEY_GROUPS.map((g) => (
        <FormRow key={g} label={KEY_GROUP_LABELS[g]} help={helpOf(read, g)}>
          <select className="ob-select" aria-label={`Model for ${KEY_GROUP_LABELS[g].toLowerCase()}`} value={read.groups[g].model} onChange={(e) => void choose(g, e.target.value)}>
            {read.modelOptions.map((m) => <option key={m.id} value={m.id}>{keyModelOptionText(m)}</option>)}
          </select>
        </FormRow>
      ))}
    </More>
  );
}
